<template>
  <div id="app">
    <router-view />
    <!-- <el-backtop target="#app" :bottom="20" :right="0"></el-backtop> -->
    <!-- 固定侧边栏 -->
    
  </div>
</template>

<script>

export default {
  name: 'App',
  
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
